import { Home, Mail, Menu, MessageSquarePlus, Ticket, UserRound, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

import { BrandLogo } from "../components/BrandLogo";
import { ThemeToggle } from "../components/ThemeToggle";
import { useSession } from "../context/SessionContext";
import { Avatar } from "../components/Avatar";

const LINKS = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/tickets", label: "My tickets", icon: Ticket },
  { to: "/new", label: "New ticket", icon: MessageSquarePlus },
];

export function CustomerShell() {
  const { status, user, error, customerLoginPending, startCustomerLogin } = useSession();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="customer-app">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="customer-header">
        <div className="customer-header__inner">
          <BrandLogo />
          <nav className="customer-nav" aria-label="Main navigation">
            {LINKS.map(({ to, label, end }) => (
              <NavLink key={to} to={to} end={end} className={({ isActive }) => isActive ? "is-active" : ""}>{label}</NavLink>
            ))}
          </nav>
          <div className="customer-header__actions">
            <ThemeToggle compact />
            {status === "authenticated" && user?.kind === "customer" ? (
              <Link className="profile-chip" to="/profile">
                <Avatar name={user.name} url={user.avatarUrl} size="small" />
                <span>{user.name}</span>
              </Link>
            ) : (
              <button className="button button--primary button--small desktop-only" type="button" disabled={customerLoginPending || status === "loading"} onClick={startCustomerLogin}>{customerLoginPending ? "Signing in…" : "Sign in"}</button>
            )}
            <button className="icon-button mobile-menu-button" type="button" onClick={() => setMenuOpen((value) => !value)} aria-expanded={menuOpen} aria-controls="mobile-menu" aria-label="Toggle menu">
              {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
            </button>
          </div>
        </div>
        {menuOpen && (
          <nav id="mobile-menu" className="mobile-menu" aria-label="Mobile menu">
            {LINKS.map(({ to, label }) => <Link key={to} to={to} onClick={() => setMenuOpen(false)}>{label}</Link>)}
            <Link to="/profile" onClick={() => setMenuOpen(false)}>Profile & notifications</Link>
            {status !== "authenticated" && <button className="button button--primary" type="button" disabled={customerLoginPending || status === "loading"} onClick={startCustomerLogin}>{customerLoginPending ? "Signing in…" : "Sign in"}</button>}
          </nav>
        )}
      </header>

      <main id="main-content" className="customer-main" tabIndex={-1}>
        {error && <div className="notice notice--warning" role="alert">{error}</div>}
        <Outlet />
      </main>

      <footer className="customer-footer">
        <div>
          <BrandLogo />
          <p>Migration support, connected to your Next-Cart account.</p>
        </div>
        <div className="customer-footer__links">
          <a href="mailto:support@next-cart.com"><Mail aria-hidden="true" size={16} /> Email support</a>
          <a href="https://docs.next-cart.com/" target="_blank" rel="noreferrer">Documentation</a>
          <Link to="/profile">Notification settings</Link>
          <a href="https://next-cart.com/data-policy" target="_blank" rel="noreferrer">Privacy</a>
        </div>
      </footer>

      <nav className="customer-bottom-nav" aria-label="Mobile navigation">
        <NavLink to="/" end><Home aria-hidden="true" /><span>Home</span></NavLink>
        <NavLink to="/tickets"><Ticket aria-hidden="true" /><span>Tickets</span></NavLink>
        <NavLink to="/new" className="customer-bottom-nav__create"><MessageSquarePlus aria-hidden="true" /><span>New</span></NavLink>
        <NavLink to="/profile"><UserRound aria-hidden="true" /><span>Profile</span></NavLink>
      </nav>
    </div>
  );
}
